import type {
  DocumentSchema,
  SearchParamsWithPreset,
} from 'typesense/lib/Typesense/Documents';
import type { SearchParams } from 'typesense/lib/Typesense/Types';
import type { SetlistContext } from './client';
import { STOCK_VIDEO_COLLECTION } from './collections';
import {
  composeStockVideoSort,
  DEFAULT_VIDEO_ENGAGEMENT_SLUG,
  STOCK_VIDEO_INCLUDE_FIELDS,
  VIDEO_ENGAGEMENT_SORT,
  VIDEO_RECENCY_TIE_BREAKER,
  withEngagementFilter,
} from './stock-video-engagement-join';

export interface GetStockFootageParams {
  isSubscribedUser?: boolean;
  searchParameters?:
    | SearchParams<DocumentSchema, string>
    | SearchParamsWithPreset<DocumentSchema, string>;
  slug?: string;
}

export const getStockFootage = async (
  context: SetlistContext,
  params?: GetStockFootageParams
) => {
  const {
    searchParameters,
    isSubscribedUser = false,
    slug = DEFAULT_VIDEO_ENGAGEMENT_SLUG,
  } = params || {};

  const accountTypeGroup = isSubscribedUser ? 'paid' : 'free';
  const existingFilter =
    searchParameters && 'filter_by' in searchParameters
      ? searchParameters.filter_by
      : undefined;
  const filterBy = withEngagementFilter(
    accountTypeGroup,
    existingFilter as string | undefined,
    slug
  );

  const response = await context.client
    .collections(STOCK_VIDEO_COLLECTION)
    .documents()
    .search(
      {
        q: '*',
        page: 1,
        per_page: 24,
        include_fields: STOCK_VIDEO_INCLUDE_FIELDS,
        sort_by: composeStockVideoSort([
          VIDEO_ENGAGEMENT_SORT,
          VIDEO_RECENCY_TIE_BREAKER,
        ]),
        ...searchParameters,
        filter_by: filterBy,
      },
      {
        cacheSearchResultsForSeconds: 0,
      }
    );

  return response;
};
